import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you

root.render(
  <BrowserRouter
    basename={process.env.NODE_ENV === "production" ? "/order" : ""}
  >
    <div className="z-50">
      <App />
    </div>
  </BrowserRouter>
);

reportWebVitals();
